import PrivacyPolicy from "./Privacy-Policy";

function Voyager(){
    return(
        <div>
            This shows due to you are in /voyager index

        </div>
    )
}

export default Voyager;